import React, { useState, useEffect } from 'react';
import { useDrag, useDrop, DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DefaultColors as Dflt } from '../components/jptr-default.js';
import { JiMinus, JiPlus } from '../components/jptr-icons';


const ItemType = 'WAGGON';

function Waggon({ color, index, originalIndex, moveWaggon }) {
    const [, ref] = useDrag({
        type: ItemType,
        item: { index },
    });

    const [, drop] = useDrop({
        accept: ItemType,
        hover: (draggedItem) => {
            if (draggedItem.index !== index) {
                moveWaggon(draggedItem.index, index);
                draggedItem.index = index;
            }
        },
    });

    const getFontColor = (hex) => {
        const rgb = hex.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        if (!rgb) return '#000000';
        const r = parseInt(rgb[1], 10);
        const g = parseInt(rgb[2], 10);
        const b = parseInt(rgb[3], 10);
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
        return brightness < 85 ? '#FFFFFF' : '#000000';
    };

    return (
        <div ref={(node) => ref(drop(node))} className="waggon" style={{ backgroundColor: color }} draggable>
            <p style={{ color: getFontColor(color) }}>{originalIndex}</p>
        </div>
    );
}

function Railway({ onOrderChange, reset }) {

    const [waggonColors] = useState(Dflt.getRGB([0, 1, 2, 3, 4, 5, 6, 7, 8]));
    const numWaggons = 4;

    const [waggonCount, setWaggonCount] = useState(numWaggons);
    const [waggons, setWaggons] = useState([...Array(numWaggons)].map((_, index) => ({
        color: waggonColors[index % waggonColors.length],
        originalIndex: index
    })));

    useEffect(() => {
        setWaggons((prevWaggons) => {
            if (waggonCount > prevWaggons.length) {
                return [
                    ...prevWaggons,
                    ...Array(waggonCount - prevWaggons.length).fill().map((_, index) => ({
                        color: waggonColors[(prevWaggons.length + index) % waggonColors.length],
                        originalIndex: prevWaggons.length + index
                    }))
                ];
            } else {
                return prevWaggons.slice(0, waggonCount);
            }
        });
    }, [waggonCount, waggonColors]);

    useEffect(() => {
        onOrderChange(waggons);
    }, [waggons, onOrderChange]);

    useEffect(() => {
        if (reset) {
            setWaggonCount(numWaggons);
            setWaggons([...Array(numWaggons)].map((_, index) => ({
                color: waggonColors[index % waggonColors.length],
                originalIndex: index
            })));
        }
    }, [reset, waggonColors]);

    const moveWaggon = (fromIndex, toIndex) => {
        const updatedWaggons = [...waggons];
        const [movedWaggon] = updatedWaggons.splice(fromIndex, 1);
        updatedWaggons.splice(toIndex, 0, movedWaggon);
        setWaggons(updatedWaggons);
    };

    return (
        <DndProvider backend={HTML5Backend}>
            <div className="flx-Hc-1">
                <JiMinus className="ji-icon" onClick={() => setWaggonCount(waggonCount > 0 ? waggonCount - 1 : 0)} />
                <div className="railCenter noselect">
                    {waggons.map((waggon, index) => (
                        <Waggon
                            key={index}
                            index={index}
                            color={waggon.color}
                            originalIndex={waggon.originalIndex}
                            moveWaggon={moveWaggon}
                        />
                    ))}
                </div>
                <JiPlus className="ji-icon" onClick={() => setWaggonCount(waggonCount < 9 ? waggonCount + 1 : 9)} />
            </div>
        </DndProvider>
    );
}

export {
    Railway
};